export const TILING_CANVAS_ROOT_PATH = 'tiling-canvas';
